import React, { useState } from 'react';
import { ResetPasswordErrorType, SetLoginForm } from '@app/models';

import { ResetPasswordValidate, ResetPasswordSuccess } from './components';
import { accountService } from '@app/services';

interface IProps {
    setLoginForm: SetLoginForm;
    resetViaPhone?: boolean;
}

const ResetPasswordSelfservicePage: React.SFC<IProps> = ({ setLoginForm, resetViaPhone }) => {
    const [isPasswordResetSuccess, setIsPasswordResetSuccess] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState<ResetPasswordErrorType>({ isUsernameInvalid: false, isEmptyUsername: false });
    const resetPassword = (username: string) => {
        setIsLoading(true);
        accountService.resetPassword(
            { username: username },
            () => {
                setIsError({ isUsernameInvalid: true, isEmptyUsername: false });
                setIsLoading(false);
            },
            () => {
                setIsPasswordResetSuccess(true);
                setIsLoading(false);
            }
        );
    };

   return (
        <>
            {isPasswordResetSuccess ? (
                <ResetPasswordSuccess setLoginForm={setLoginForm} />
            ) : (
                <ResetPasswordValidate
                    onSubmit={resetPassword}
                    setLoginForm={setLoginForm}
                    isLoading={isLoading}
                    isError={isError}
                />
            )}
        </>
    );
};

export default ResetPasswordSelfservicePage;
